<template>
    <div>
      Janaka
    </div>
</template>

<script>
    export default {
        name: "stepOne"
    }
</script>

<style scoped>

</style>
